import { Component, OnInit } from '@angular/core';
import * as bootstrap from "bootstrap";
import * as $AB from 'jquery';

@Component({
  selector: 'app-dataoffering',
  templateUrl: './dataoffering.component.html',
  styleUrls: ['./dataoffering.component.css']
})
export class DataofferingComponent implements OnInit {

  p:any;
  constructor() { }
  posts=[
  {'offering':'MRI scan','type':'Algorithm','create_date':'01/12/2016'},
  {'offering':'Healthcare','type':'Data Asset','create_date':'05/11/2016'},
   {'offering':'MRI scan','type':'Algorithm','create_date':'01/12/2016'},
   {'offering':'Healthcare','type':'Data Asset','create_date':'05/11/2016'},
]
  ngOnInit(): void {
  $(".header-title p").text('Data Offering');
    }

}
